<div class="DocumentViewer-desktop">
  <div class="row">
    <div [ngClass]="leftColClass">
      <!-- DEMO MODE COMPONENT -->
      <document-demo-content
        *ngIf="docData.demo"
        [data]="docData"
        [partialAuth]="currentUser?.partialAuth"
        [company]="currentUser?.companyId">
      </document-demo-content>
      <!-- NOT DEMO MODE -->
      <div *ngIf="!docData.demo" class="DocumentContainer" [ngClass]="isFlashFormat(docData)">
        <!-- TOPICS -->
        <div class="Topics-container-desktop" [ngClass]="isFlashFormat(docData)" *ngIf="featureFlagService.isTopicsContainerEnabled()">
          <icullen-topics [topics]="docData.topics"></icullen-topics>
        </div>
        <!-- DOC TITLE -->
        <div
          class="DocumentTitle"
          [ngClass]="titleWithButtons"
          [class.NoBorder]="isFlashFormat(docData) && docData.tabAnchors.showTabs"
          *ngIf="!docData.hideTitleBanner">
          <h1 [ngClass]="shouldApplyPaddingRight(docData)">
            {{ docData.title }}
            <a
              *ngIf="docData.containingPublication"
              [routerLink]="getPublicationLink()"
              [queryParams]="{ version: 'this' }"
              class="BackToToc"
              (click)="resetTabToFirstOnClick()"
              >Table of content</a
            >
            <a *ngIf="shouldShowDatabaseButton(docData)" [routerLink]="'/site/case-database/' + docData.documentType.name" class="BackToToc"
              >Database</a
            >
          </h1>
          <footer>
            <p>{{ "uishared.regions." + docData.regionCode | transloco }} - {{ docData.creator }} - {{ docData.publicationDate }}</p>
            <!-- ACTION ICONS COMPONENT -->
            <div class="Icons">
              <document-action-icons
                [data]="getActionIconsData()"
                (favoriteChanged)="onFavoriteChanged($event)"
                (pdfPrintButtonClicked)="addButtonClickAnalyticsData($event)">
              </document-action-icons>
            </div>
          </footer>
        </div>
        <!-- MORE RECENT VERSION WARNING BOX COMPONENT -->
        <div *ngIf="!docData.latest" class="DocumentVersion alert alert-info" role="alert">
          <h3>
            <a [routerLink]="'/site/documents/' + docData.uniqueNumber"> <b>A more recent version</b> of this document is available </a>
          </h3>
        </div>
        <!-- DOC CONTENT -->
        <div class="DocumentContent">
          <!-- TOC IN RR AND FLASHES -->
          <section-based-toc *ngIf="shouldShowSectionBasedToc(docData)" [docData]="docData" [isMobile]="false" [isSticky]="false">
          </section-based-toc>
          <!-- MATERIAL TABS -->
          <mat-tab-group
            animationDuration="0ms"
            [class.ShowTabs]="showTabs() && this.docData.documentType.name != 'BIG5'"
            (selectedTabChange)="onTabChanged($event)"
            #tabs>
            <!-- IF BIG 5 -->
            <mat-tab label="Overview" *ngIf="docData.documentType.name === 'PUBLICATION_BIG5'">
              <document-country-update-desktop [tocCountryBased]="docData.cullenPublicationDto.tableOfContentDto.tocCountryBased">
              </document-country-update-desktop>
            </mat-tab>
            <!-- IF NOT BIG 5 -->
            <ng-container *ngIf="docData.documentType.name != 'PUBLICATION_BIG5'">
              <mat-tab label="{{ tabContent.tabName }}" *ngFor="let tabContent of this.docData.tabAnchors.tabAnchorList; let i = index">
                <div [ngClass]="isTrackerFormat(docData)">
                  <!-- COMP LAW CASE HEADER -->
                  <document-competition-law
                    *ngIf="shouldShowCaseHeader(i, docData)"
                    [keywords]="docData.keywords"
                    [emphasisSections]="getEmphasisSectionsByTabName(tabContent.tabName)"
                    [countryCode]="docData.countryCode"
                    [calculatedValues]="docData.calculatedValues"
                    [documentType]="docData.documentType.name"
                    [infringements]="getInfrigements()"
                    [aim]="getAim()"
                    [target]="getTarget()"
                    [dmaSubthemes]="getDmaSubthemes()"
                    [dmaCps]="getDmaCps()"
                    [dmaEmphasisSections]="getDmaEmphasisSectionsByTypeName(tabContent.tabName)">
                  </document-competition-law>
                  <!-- SECTIONS -->
                  <document-section
                    *ngFor="let section of getSectionsByTabName(tabContent.tabName)"
                    [section]="section"
                    [uniqueNumber]="docData.uniqueNumber"
                    [documentType]="docData.documentType.name"
                    [showSectionName]="tabContent.indexes.length > 1"
                    [isMobile]="false"
                    [user]="currentUser?.UserType">
                  </document-section>
                  <!-- TOC IN EXISTING TAB -->
                  <document-toc-container
                    *ngIf="docData.cullenPublicationDto && docData.cullenPublicationDto.tableOfContentDto.execSummaryInToc"
                    [tocType]="docData.cullenPublicationDto.tocType"
                    [pillars]="docData.cullenPublicationDto.tableOfContentDto.tocPillars"
                    [groups]="docData.cullenPublicationDto.tableOfContentDto.groups"
                    [newIndicatorDays]="docData.cullenPublicationDto.tableOfContentDto.newIndicatorDays">
                  </document-toc-container>
                </div>
              </mat-tab>
              <!-- TOC IN NEW TAB -->
              <mat-tab
                label="Table of content"
                *ngIf="docData.cullenPublicationDto && !docData.cullenPublicationDto.tableOfContentDto.execSummaryInToc">
                <document-toc-container
                  [tocType]="docData.cullenPublicationDto.tocType"
                  [pillars]="docData.cullenPublicationDto.tableOfContentDto.tocPillars"
                  [groups]="docData.cullenPublicationDto.tableOfContentDto.groups"
                  [newIndicatorDays]="docData.cullenPublicationDto.tableOfContentDto.newIndicatorDays">
                </document-toc-container>
              </mat-tab>
            </ng-container>
            <!-- OTHER VERSIONS -->
            <mat-tab label="Other versions" *ngIf="showOtherVersions()">
              <div class="OtherVersions">
                <ul>
                  <li *ngFor="let version of docData.versions" [ngClass]="getOtherVersionDisplayClass(version.uniqueNumber)">
                    <other-version-desktop
                      [versionDoc]="version"
                      [currentVersionUniqueNumber]="docData.uniqueNumber"
                      (otherVersionClicked)="resetTabToFirst($event)">
                    </other-version-desktop>
                  </li>
                </ul>
              </div>
            </mat-tab>
            <!-- ATTACHMENT -->
            <mat-tab *ngIf="docData.collectionAttachments" label="{{ docData.attachemntDescription }}">
              <div class="Attachment">
                <h2 *ngIf="docData.authority">{{ "uishared.authority." + docData.authority | transloco }}</h2>
                <header>
                  <h3>
                    {{ docData.collectionAttachments.attachments.length }}
                    <span [innerText]="getAttachmentsTitle(docData.collectionAttachments.attachments.length)"></span>
                  </h3>
                  <a href="/product/attachments/{{ docData.uniqueNumber }}.zip">Download all as Zip</a>
                </header>
                <ul class="PdfList">
                  <li *ngFor="let attachment of docData.collectionAttachments.attachments">
                    <a href="/product/binarydocs/{{ attachment.id }}" target="fromDocViewer">
                      <h4>{{ attachment.name }}</h4>
                      <p *ngIf="attachment.description">{{ attachment.description }}</p>
                    </a>
                  </li>
                </ul>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
        <!-- ACTION BOTTOM BAR // USED ONCE -->
        <div class="ActionBottomBar">
          <p>
            Report N°:
            <b *ngIf="docData.documentType.name != 'BIG5_SECTION'">{{ docData.uniqueNumber }}</b>
            <b *ngIf="docData.documentType.name === 'BIG5_SECTION'">{{ showCountryUpdateUniqueNumber(docData.uniqueNumber) }}</b>
          </p>
          <document-action-icons
            [data]="getActionIconsData()"
            (favoriteChanged)="onFavoriteChanged($event)"
            (pdfPrintButtonClicked)="addButtonClickAnalyticsData($event)">
          </document-action-icons>
        </div>
      </div>
    </div>
    <div [ngClass]="rightColClass" *ngIf="!docData.hideTitleBanner">
      <!-- SUBSCRIBE BUTTON -->
      <icullen-subscribe *ngIf="docData.demo && !currentUser?.partialAuth" [subscriptionInfo]="getSusbscriptionInfo()"></icullen-subscribe>
      <!-- LOGIN -->
      <div class="Login" *ngIf="showLogin()">
        <button type="submit" class="Button" value="Login" (click)="login()">Login</button>
      </div>
      <!-- RELATED POST COMPONENT -->
      <div class="RelatedDocs">
        <!-- RELATED POSTS -->
        <related-docs
          *ngIf="docData.relatedDocuments.length > 0"
          [relatedDocuments]="docData.relatedDocuments"
          [docType]="docData.documentType.name"></related-docs>
        <!-- SIMILAR POSTS -->
        <similar-docs *ngIf="similarDocs?.length > 0 && docData.publication === false" [similarDocuments]="similarDocs"></similar-docs>
      </div>
      <!-- STICKY TOC IN RR AND FLASHES -->
      <div class="Sticky-container">
        <section-based-toc *ngIf="shouldShowSectionBasedToc(docData)" [docData]="docData" [isMobile]="false" [isSticky]="true">
        </section-based-toc>
      </div>
    </div>
  </div>
</div>
